<template>
  <div>
    <div class="flex justify-between items-center mt-20px">
      <span class="border-l-3 border-color-primary pl-10px text-18px"
        >承包商负责人及项目经理简介</span
      >
    </div>
    <el-form
      ref="form"
      :model="formData"
      label-width="100px"
      class="p-20px clear-placeholer "
      v-loading="formDataLoading"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="负责人" prop="name">
            <el-input v-model="formData.name" placeholder="请输入负责人" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="学历" prop="degree">
            <el-select
              size="small"
              class="w-full"
              filterable
              placeholder="请选择学历"
              v-model="formData.degree"
              disabled
            >
              <el-option
                v-for="item in educationList"
                :key="item.code"
                :label="item.displayName"
                :value="Number(item.code)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="年龄" prop="age">
            <el-input disabled v-model="formData.age" placeholder="请输入年龄"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="工作年限" prop="workYears">
            <el-input disabled v-model="formData.workYears" placeholder="请输入工作年限"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="手机" prop="phone">
            <el-input
              disabled
              size="small"
              v-model="formData.phone"
              placeholder="请输入手机"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="8">
          <el-form-item label="工作业绩" prop="workDescription">
            <el-input
              disabled
              size="small"
              v-model="formData.workDescription"
              placeholder="请输入工作业绩"
            ></el-input>
          </el-form-item>
        </el-col> -->
      </el-row>
    </el-form>
    <div class="flex justify-between items-center mt-20px">
      <span class="border-l-3 border-color-primary pl-10px text-18px">公司资质情况</span>
    </div>
    <el-table
      :data="companyQualificationsList"
      border
      stripe
      class="mt-20px"
      v-loading="companyQualificationsLoading"
    >
      <el-table-column type="index" label="序号" width="60" show-overflow-tooltip></el-table-column>
      <el-table-column label="资质类型/名称" prop="categoryCodeName" show-overflow-tooltip
        ><template slot-scope="scope">
          <span
            class="cursor-pointer"
            :class="{ 'is-down': scope.row.fileId }"
            @click="downLoadFile(scope.row)"
          >
            {{ scope.row.categoryCodeName }}
          </span>
        </template></el-table-column
      >
      <el-table-column label="证书编号" prop="_number" show-overflow-tooltip></el-table-column>
      <el-table-column label="有效期限" prop="validDateEnd" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>
            {{
              scope.row.validDateEnd && dayjs(scope.row.validDateEnd).format('YYYY-MM-DD HH:mm:ss')
            }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="companyQualificationsTableSizeChange"
      @current-change="companyQualificationsTableCurrentChange"
      :current-page.sync="companyQualificationsPageConfig.SkipCount"
      :page-size.sync="companyQualificationsPageConfig.MaxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="companyQualificationsPageConfig.total"
      class="float-right mt-20px ml-20px clear-both"
    ></el-pagination>
    <div class="flex justify-between items-center mt-68px">
      <span class="border-l-3 border-color-primary pl-10px text-18px">补充资质情况</span>
      <el-button type="primary" @click="handleSuppleQualifications">上传</el-button>
    </div>
    <el-table :data="suppleQualificationsList" border stripe class="mt-20px">
      <el-table-column type="index" label="序号" width="60" show-overflow-tooltip></el-table-column>
      <el-table-column label="资质类型/名称" prop="categoryCodeName" show-overflow-tooltip>
        <template slot-scope="scope">
          <span
            class="cursor-pointer"
            :class="{ 'is-down': scope.row.fileId }"
            @click="downLoadFile(scope.row)"
          >
            {{ scope.row.categoryCodeName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="证书编号" prop="_number" show-overflow-tooltip></el-table-column>
      <el-table-column label="有效期限" prop="validDateEnd" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>
            {{
              scope.row.validDateEnd && dayjs(scope.row.validDateEnd).format('YYYY-MM-DD HH:mm:ss')
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="280">
        <template slot-scope="scope">
          <el-button size="mini" @click="handlesuppleQualificationsRow(scope.row, 'delete')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="suppleQualificationsTableSizeChange"
      @current-change="suppleQualificationsTableCurrentChange"
      :current-page.sync="suppleQualificationsPageConfig.SkipCount"
      :page-size.sync="suppleQualificationsPageConfig.MaxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="suppleQualificationsPageConfig.total"
      class="float-right mt-20px ml-20px clear-both"
    ></el-pagination>
    <div class="flex justify-between items-center mt-68px">
      <span class="border-l-3 border-color-primary pl-10px text-18px">安全生产业绩</span>
      <el-button type="primary" @click="addSafetyProductPerformance">添加行</el-button>
    </div>
    <div class="max-h-274px overflow-y-scroll">
      <el-table :data="safetyProductPerformance" border stripe class="mt-20px">
        <el-table-column
          type="index"
          label="序号"
          width="60"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="安全业绩" prop="description" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.description"
              :disabled="scope.row.editSafetyProductPerformance"
              placeholder="请输入安全业绩"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.remark"
              :disabled="scope.row.editSafetyProductPerformance"
              placeholder="请输入备注"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="280">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="scope.row.editSafetyProductPerformance = false"
              :disabled="!scope.row.editSafetyProductPerformance"
              >编辑</el-button
            >
            <el-button
              size="mini"
              @click="handlesafetyProductPerformance(scope.row, 'save')"
              :disabled="scope.row.editSafetyProductPerformance"
              >保存</el-button
            >
            <el-button
              size="mini"
              @click="handlesafetyProductPerformance(scope.row, 'delete', scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="flex justify-between items-center mt-68px">
      <span class="border-l-3 border-color-primary pl-10px text-18px">安全生产档案</span>
      <el-button type="primary" @click="handleInsecurityEvent">上传</el-button>
    </div>
    <el-table :data="insecurityEventList" border stripe class="mt-20px">
      <el-table-column type="index" label="序号" width="60" show-overflow-tooltip></el-table-column>
      <el-table-column label="不安全事件" prop="name" show-overflow-tooltip></el-table-column>
      <el-table-column label="考核" prop="assessment" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleInsecurity(scope.row, 'edit')">编辑</el-button>
          <el-button size="mini" @click="handleInsecurity(scope.row, 'delete')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="insecurityEventTableSizeChange"
      @current-change="insecurityEventTableCurrentChange"
      :current-page.sync="insecurityEventPageConfig.SkipCount"
      :page-size.sync="insecurityEventPageConfig.MaxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="insecurityEventPageConfig.total"
      class="float-right mt-20px ml-20px clear-both"
    ></el-pagination>
    <div class="flex justify-between items-center mt-68px">
      <span class="border-l-3 border-color-primary pl-10px text-18px">奖励与考核信息</span>
      <el-button type="primary" @click="addRewardAndAssessment">上传</el-button>
    </div>
    <el-table :data="rewardsAndAssessmentList" border stripe class="mt-20px">
      <el-table-column type="index" label="序号" width="60" show-overflow-tooltip></el-table-column>
      <el-table-column label="奖励情况" prop="reward" show-overflow-tooltip></el-table-column>
      <el-table-column label="考核情况" prop="assessment" show-overflow-tooltip></el-table-column>
      <el-table-column label="其它情况" prop="other" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleRewardAndAssessment(scope.row, 'edit')"
            >编辑</el-button
          >
          <el-button size="mini" @click="handleRewardAndAssessment(scope.row, 'delete')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="rewardsAndAssessmentTableSizeChange"
      @current-change="rewardsAndAssessmentTableCurrentChange"
      :current-page.sync="rewardsAndAssessmentPageConfig.SkipCount"
      :page-size.sync="rewardsAndAssessmentPageConfig.MaxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="rewardsAndAssessmentPageConfig.total"
      class="float-right mt-20px ml-20px clear-both"
    ></el-pagination>
    <!-- 上传补充资质 -->
    <AddSuppleQualifications
      v-model="addSuppleQualificationsVisible"
      :workPermitCategoryList="workPermitCategoryList"
      :workPermitId="workPermitId"
    />
    <!-- 上传不安全事件 -->
    <AddInsecurityEvent
      v-model="addInsecurityEventVisible"
      :contractorId="contractorId"
      :saveInsecurityEventRow="saveInsecurityEventRow"
    />
    <!-- 上传奖励考核信息 -->
    <AddRewardsAndAssessment
      v-model="addRewardsAndAssessmentVisible"
      :contractorId="contractorId"
      :saveRewardAndAssessmentRow="saveRewardAndAssessmentRow"
    />
  </div>
</template>
<script>
import clearPlaceholder from '@/assets/js/safety/ClearPlaceholder'
import utils from '@/components/safety/enumField/utils'
import {
  WorkPermitApi,
  ContractorApi,
  WorkPermitGuidanceFileApi,
  WorkPermitAddtionalGuidanceConfigurationDirectoriesApi,
  WorkPermitGuidanceConfigurationDirectoryApi,
} from '@wiz-api/contractor-management'
import { FileApi } from '@wiz-api/file-management'
import AddSuppleQualifications from './addSuppleQualifications'
import AddInsecurityEvent from './addInsecurityEvent'
import AddRewardsAndAssessment from './addRewardsAndAssessment'

const fileApi = new FileApi()
const workPermitAddtionalGuidanceConfigurationDirectorysApi = new WorkPermitAddtionalGuidanceConfigurationDirectoriesApi()
const workPermitGuidanceFileApi = new WorkPermitGuidanceFileApi()
const contractorApi = new ContractorApi()
const workPermitGuidanceConfigurationDirectoryApi = new WorkPermitGuidanceConfigurationDirectoryApi()
export default {
  components: {
    AddSuppleQualifications,
    AddInsecurityEvent,
    AddRewardsAndAssessment,
  },
  data() {
    return {
      formDataLoading: false,
      workPermitCategoryList: [],
      saveRewardAndAssessmentRow: {},
      rewardsAndAssessmentList: [],
      addRewardsAndAssessmentVisible: false,
      rewardsAndAssessmentPageConfig: {
        SkipCount: 1,
        MaxResultCount: 10,
        total: 0,
      },
      editSafetyProductPerformance: true,
      safetyProductPerformance: [],
      saveInsecurityEventRow: {},
      insecurityEventList: [],
      addInsecurityEventVisible: false,
      insecurityEventPageConfig: {
        SkipCount: 1,
        MaxResultCount: 10,
        total: 0,
      },
      suppleQualificationsList: [],
      suppleQualificationsPageConfig: {
        SkipCount: 1,
        MaxResultCount: 10,
        total: 0,
      },
      companyQualificationsLoading: false,
      companyQualificationsList: [],
      addSuppleQualificationsVisible: false,
      educationList: [],
      formData: {},
      companyQualificationsPageConfig: {
        SkipCount: 1,
        MaxResultCount: 10,
        total: 0,
      },
      permitIds: [],
    }
  },
  props: {
    workPermitId: {
      default: null,
    },
    contractorId: {
      type: String,
      default: '',
    },
  },
  watch: {
    addInsecurityEventVisible(val) {
      if (!val) {
        this.insecurityEventPageConfig.SkipCount = 1
        this.getInsecurityEvent()
      }
    },
    addRewardsAndAssessmentVisible(val) {
      if (!val) {
        this.rewardsAndAssessmentPageConfig.SkipCount = 1
        this.getRewardsAndAssessment()
      }
    },
    addSuppleQualificationsVisible(val) {
      if (!val) {
        this.suppleQualificationsPageConfig.SkipCount = 1
        this.getSuppleQualifications()
      }
    },
  },
  async created() {
    await utils.getDataCategory(
      [
        'ContractorManagement.DataCategory.Education',
        'ContractorManagement.DataCategory.WorkPermitCategory',
      ],
      ['educationList', 'workPermitCategoryList'],
      this
    )
    await this.getContractDetail()
    await this.getCompanyQualifications()
    this.getSuppleQualifications()
    this.getCompanySafetyPerformance()
    this.getInsecurityEvent()
    this.getRewardsAndAssessment()
  },
  mounted() {
    clearPlaceholder('.clear-placeholer')
  },
  methods: {
    // 附件，下载
    async downLoadFile(item) {
      if (!item.fileId) {
        this.$message.error('文件不存在')
        return
      }
      const [infoErr, file] = await fileApi.getFileInfoVersion(item.fileId)
      if (infoErr) {
        return
      }
      const [err, res] = await fileApi.download(file.id, { returnType: 'Blob' })
      if (!err) {
        this.exportFile(res, file.name)
      }
    },
    // 下载文件
    exportFile(data, name) {
      const blob = new Blob([data], {
        type: 'application/pdf',
      })
      const blobUrl = window.URL.createObjectURL(blob)
      const templink = document.createElement('a')
      templink.style.display = 'none'
      templink.href = blobUrl
      templink.setAttribute('download', `${name}`)
      document.body.appendChild(templink)
      templink.click()
      document.body.removeChild(templink)
      window.URL.revokeObjectURL(blobUrl)
      this.$message({
        type: 'success',
        message: '下载成功!',
      })
    },
    // 获取承包商信息
    async getContractDetail() {
      const [error, res] = await contractorApi.get(this.contractorId)

      if (!error) {
        this.permitIds = res.permitIds
        // 获取负责人信息
        this.formDataLoading = true
        const [err, contractorRes] = await contractorApi.getLeaderInfo(
          this.contractorId,
          res.orgLeader
        )
        if (!err) {
          this.formData = contractorRes
          this.formData.workYears = contractorRes.workYears ? `${contractorRes.workYears}年` : ''
        }
        this.formDataLoading = false
      }
    },
    //
    handleRewardAndAssessment(row, type) {
      if (type === 'edit') {
        this.addRewardsAndAssessmentVisible = true
        this.saveRewardAndAssessmentRow = JSON.parse(JSON.stringify(row))
      } else {
        this.$confirm('请确认是否删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const [err, res] = await contractorApi.deleteRewardAndAssessment(
              this.contractorId,
              row.id
            )
            if (!err) {
              this.$message.success('删除成功')
              this.getRewardsAndAssessment()
            }
          })
          .catch(() => {})
      }
    },
    // 上传奖励考核信息
    addRewardAndAssessment() {
      this.addRewardsAndAssessmentVisible = true
    },
    // 奖励考核信息页码改变
    rewardsAndAssessmentTableSizeChange(MaxResultCount) {
      this.rewardsAndAssessment.MaxResultCount = MaxResultCount
      this.getRewardsAndAssessment()
    },
    // 奖励考核信息页数改变
    rewardsAndAssessmentTableCurrentChange(SkipCount) {
      this.rewardsAndAssessmentPageConfig.SkipCount = SkipCount
      this.getRewardsAndAssessment()
    },
    async getRewardsAndAssessment() {
      // 获取奖励考核信息
      const [err, res] = await contractorApi.getRewardAndAssessmentsByPage(this.contractorId, {
        skipCount:
          (this.rewardsAndAssessmentPageConfig.SkipCount - 1) *
          this.rewardsAndAssessmentPageConfig.MaxResultCount,
        maxResultCount: this.rewardsAndAssessmentPageConfig.MaxResultCount,
      })
      if (!err) {
        this.rewardsAndAssessmentList = res.items
        this.rewardsAndAssessmentPageConfig.total = res.totalCount
      }
    },
    handlesuppleQualificationsRow(row, type) {
      this.$confirm('请确认是否删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await workPermitAddtionalGuidanceConfigurationDirectorysApi.callDelete(
            {
              id: row.id,
            }
          )
          if (!err) {
            this.$message.success('删除成功')
            this.suppleQualificationsPageConfig.SkipCount = 1
            this.getSuppleQualifications()
          }
        })
        .catch(() => {})
    },
    handleSuppleQualifications() {
      this.addSuppleQualificationsVisible = true
    },
    // 页码改变
    companyQualificationsTableSizeChange(MaxResultCount) {
      this.companyQualificationsPageConfig.MaxResultCount = MaxResultCount
      this.getCompanyQualifications()
    },
    // 页数改变
    companyQualificationsTableCurrentChange(SkipCount) {
      this.companyQualificationsPageConfig.SkipCount = SkipCount
      this.getCompanyQualifications()
    },
    // 获取公司资质信息
    async getCompanyQualifications() {
      this.companyQualificationsLoading = true
      const [err, res] = await workPermitGuidanceConfigurationDirectoryApi.getByPage({
        body: {
          permitIds: this.permitIds,
          skipCount:
            (this.companyQualificationsPageConfig.SkipCount - 1) *
            this.companyQualificationsPageConfig.MaxResultCount,
          maxResultCount: this.companyQualificationsPageConfig.MaxResultCount,
        },
      })
      if (!err) {
        this.companyQualificationsList = res.items.map((item) => {
          this.workPermitCategoryList.forEach((category) => {
            if (item.categoryCode === Number(category.code)) {
              item.categoryCodeName = category.displayName
            }
          })
          return item
        })
        this.companyQualificationsPageConfig.total = res.totalCount
      }
      this.companyQualificationsLoading = false
    },
    async getSuppleQualifications() {
      // 获取补充资质信息
      const [err, res] = await workPermitAddtionalGuidanceConfigurationDirectorysApi.getByPage({
        permitId: this.workPermitId, // 承包商id
        skipCount:
          (this.suppleQualificationsPageConfig.SkipCount - 1) *
          this.suppleQualificationsPageConfig.MaxResultCount,
        maxResultCount: this.suppleQualificationsPageConfig.MaxResultCount,
      })
      if (!err) {
        this.suppleQualificationsList = res.items.map((item) => {
          this.workPermitCategoryList.forEach((category) => {
            if (item.categoryCode === Number(category.code)) {
              item.categoryCodeName = category.displayName
            }
          })
          return item
        })
        this.suppleQualificationsPageConfig.total = res.totalCount
      }
    },
    // 补充资质页码改变
    suppleQualificationsTableSizeChange(MaxResultCount) {
      this.suppleQualificationsPageConfig.MaxResultCount = MaxResultCount
      this.getSuppleQualifications()
    },
    // 补充资质页数改变
    suppleQualificationsTableCurrentChange(SkipCount) {
      this.suppleQualificationsPageConfig.SkipCount = SkipCount
      this.getSuppleQualifications()
    },
    // 安全业绩
    addSafetyProductPerformance() {
      this.safetyProductPerformance.push({
        description: '',
        remark: '',
      })
    },
    async getCompanySafetyPerformance() {
      // 获取安全业绩
      const [err, res] = await contractorApi.getCompanySafetyPerformance(this.contractorId)
      if (!err) {
        this.safetyProductPerformance = res.map((item) => {
          return {
            ...item,
            editSafetyProductPerformance: true,
          }
        })
      }
    },
    async handlesafetyProductPerformance(row, type, index) {
      if (type === 'save') {
        // 保存
        if (!row.editSafetyProductPerformance && !row.id) {
          const [err, res] = await contractorApi.createCompnaySafetyPerformance(this.contractorId, {
            body: row,
          })
          if (!err) {
            this.$message.success('保存成功')
            this.getCompanySafetyPerformance()
          }
        } else {
          const [err, res] = await contractorApi.updateCompnaySafetyPerformance(
            this.contractorId,
            row.id,
            {
              body: row,
            }
          )
          if (!err) {
            this.getCompanySafetyPerformance()
            this.$message.success('编辑成功')
          }
        }
      } else if (type === 'delete') {
        if (!row.id) {
          this.safetyProductPerformance.splice(index, 1)
          return
        }
        this.$confirm('请确认是否删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const [err, res] = await contractorApi.deleteCompnaySafetyPerformance(
              this.contractorId,
              row.id
            )
            if (!err) {
              this.$message.success('删除成功')
              this.getCompanySafetyPerformance()
            }
          })
          .catch(() => {})
      }
    },
    // 安全生产事件
    handleInsecurityEvent() {
      this.saveInsecurityEventRow = {}
      this.addInsecurityEventVisible = true
    },
    async handleInsecurity(row, type) {
      this.saveInsecurityEventRow = {}
      if (type === 'edit') {
        this.addInsecurityEventVisible = true
        this.saveInsecurityEventRow = JSON.parse(JSON.stringify(row))
      } else {
        this.$confirm('请确认是否删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const [err, res] = await contractorApi.deleteSafetyProductionFile(
              this.contractorId,
              row.id
            )
            if (!err) {
              this.$message.success('删除成功')
              this.insecurityEventPageConfig.SkipCount = 1
              this.getInsecurityEvent()
            }
          })
          .catch(() => {})
      }
    },
    async getInsecurityEvent() {
      // 获取安全业绩
      const [err, res] = await contractorApi.getSafetyProductionFilesByPage(this.contractorId, {
        skipCount:
          (this.insecurityEventPageConfig.SkipCount - 1) *
          this.insecurityEventPageConfig.MaxResultCount,
        maxResultCount: this.insecurityEventPageConfig.MaxResultCount,
      })
      if (!err) {
        this.insecurityEventList = res.items
        this.insecurityEventPageConfig.total = res.totalCount
      }
    },
    //  安全业绩页码改变
    insecurityEventTableSizeChange(MaxResultCount) {
      this.insecurityEventPageConfig.MaxResultCount = MaxResultCount
      this.getInsecurityEvent()
    },
    //  安全业绩页数改变
    insecurityEventTableCurrentChange(SkipCount) {
      this.insecurityEventPageConfig.SkipCount = SkipCount
      this.getInsecurityEvent()
    },
  },
}
</script>
<style lang="scss" scoped>
.is-down {
  color: #1684fc;
  text-decoration: underline;
}
</style>
